import { render, staticRenderFns } from "./MasterPhrase.vue?vue&type=template&id=4779b13c&scoped=true&lang=pug&"
import script from "./scripts/MasterPhrase.js?vue&type=script&lang=js&"
export * from "./scripts/MasterPhrase.js?vue&type=script&lang=js&"
import style0 from "./MasterPhrase.vue?vue&type=style&index=0&id=4779b13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4779b13c",
  null
  
)

export default component.exports